import SvgBrain from "@Components/CustomIcon/SvgBrain"
import SvgLegume from "@Components/CustomIcon/SvgLegume"
import SvgPhysics from "@Components/CustomIcon/SvgPhysics"
import { SvgStethoscopeIcon } from "@Components/CustomIcon/SvgStethoscopeIcon"
import SvgTools from "@Components/CustomIcon/SvgTools"
import SvgVideoCall from "@Components/CustomIcon/SvgVideoCall"

const getAxisIcon = (id) => {
    switch (id) {
        case 1:
            return (
                <SvgPhysics style={{ position: "absolute", top: 20, alignSelf: "flex-end" }} height={54} width={54} />
            )
        case 2:
            return (
                <SvgLegume
                    style={{ position: "absolute", top: 20, alignSelf: "flex-end", right: "15%" }}
                    height={54}
                    width={54}
                />
            )
        case 3:
            return (
                <SvgBrain
                    style={{ position: "absolute", top: 25, alignSelf: "flex-end", right: "15%" }}
                    height={54}
                    width={54}
                />
            )
        case 4:
            return (
                <SvgStethoscopeIcon
                    style={{ position: "absolute", top: 20, alignSelf: "flex-end", right: "15%" }}
                    height={54}
                    width={54}
                />
            )
        case 5:
            return (
                <SvgTools
                    style={{ position: "absolute", top: 20, alignSelf: "flex-end", right: "15%" }}
                    height={54}
                    width={54}
                />
            )
        default:
            return (
                <SvgVideoCall
                    style={{ position: "absolute", top: 20, alignSelf: "flex-end", right: "15%" }}
                    height={54}
                    width={54}
                />
            )
    }
}

export { getAxisIcon }
